<mat-card [style.transform]="'translate('+ (x) + 'px, ' + (y) + 'px' + ')'" [style.display]="((active) ? 'block' : 'none')" #matCard>
  <div class="options">
    <div class="option" *ngFor="let opt of options" (click)="opt.callback(); option_clicked($event);">
      {{opt.name}}
    </div>
  </div>
</mat-card>
